<template>
  <div
    :class="[
      'checkout-timer',
      state_class,
      { 'checkout-timer--minimal': minimal },
    ]"
  >
    {{ display }}
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  import { timer_display } from '@liveflight/utilities';

  export default {
    name: 'checkout-timer',
    props: {
      start: {
        type: Number,
        default: 0,
      },
      amount: {
        type: Number,
        default: 120,
      },
      notice: {
        type: Number,
        default: -1,
      },
      minimal: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        now: Date.now(),
        tick_handle: null,
      };
    },
    computed: {
      ...mapState('liveflight', ['offer_expiring_notice_emitted']),
      duration_ms() {
        return this.amount * 1000;
      },
      remaining_ms() {
        if (!this.start) {
          return 0;
        }
        const elapsed = this.now - this.start;
        return this.duration_ms - elapsed;
      },
      is_expired() {
        return this.start > 0 && this.remaining_ms <= 0;
      },
      is_warning() {
        return (
          !this.is_expired &&
          this.notice > 0 &&
          this.remaining_ms <= this.notice * 1000
        );
      },
      state_class() {
        if (this.is_expired) return 'checkout-timer--expired';
        if (this.is_warning) return 'checkout-timer--warning';
        return '';
      },
      display() {
        if (!this.start) return '--:--';
        if (this.minimal) return timer_display(this.remaining_ms);
        if (this.is_expired) return 'La proposta è scaduta';
        return `La proposta scade tra ${timer_display(this.remaining_ms)}`;
      },
    },
    mounted() {
      if (!this.start) return;
      this.tick_handle = setInterval(() => {
        this.now = Date.now();
        if (!this.offer_expiring_notice_emitted && this.is_warning) {
          this.$emit('notice');
        }
        if (this.is_expired) {
          this.$emit('expired');
          this.clear_ticker();
        }
      }, 250);
    },
    beforeDestroy() {
      this.clear_ticker();
    },
    methods: {
      clear_ticker() {
        if (this.tick_handle) {
          clearInterval(this.tick_handle);
          this.tick_handle = null;
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  .checkout-timer {
    font-family: $font-family-monospace;
    font-size: $font-size-lg;
    color: $gray-600;
    margin-bottom: 0.5rem;
    font-weight: $vb-font-weight-semibold;

    &--warning,
    &--expired {
      color: $danger;
    }

    &--minimal {
      display: inline;
    }
  }
</style>
